if (!customElements.get('scoreggia-language-picker')) {
  customElements.define('scoreggia-language-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.languageChangeHandler) return;
      this.languageChangeHandler = (event) => {
        if (event.target.matches('select[name="language_code"]')) {
          event.target.form.requestSubmit();
        }
      };
      this.addEventListener('change', this.languageChangeHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.languageChangeHandler);
      this.languageChangeHandler = null;
    }
  });
}
